var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { CustomElement, P, Watch, PropertyConverters, Utils, Storage } from '@pacem/pacem-core';
import { buildWidgetMetadata } from '../types';
import { PacemBearerWidgetElement, ACCESS_TOKEN_METADATA } from './types';
import { SwaggerCmsParser } from '../../openapi/swagger-cms';
//namespace Pacem.Components.Cms {
const APIMANIFEST_METADATA = {
    display: { icon: 'cloud_circle', name: 'Api Manifest', description: 'OpenApi parser for WebApi scaffolding.' },
    props: [
        {
            prop: 'url', type: 'text', display: {
                name: 'Url', description: 'Insert the url of the OpenApi json configuration.', cssClass: ['cols-lg-8'],
                watermark: 'https://domain.com/swagger/v1/swagger.json'
            },
            extra: { tooltip: true },
            validators: [{
                    type: 'required', errorMessage: 'Url field is required.'
                }]
        },
        {
            prop: 'usecache', type: 'boolean', display: {
                name: 'Cache results', description: 'Whether to cache the manifest per-url.', cssClass: ['cols-lg-4'],
                ui: 'switcher'
            },
            extra: { tooltip: true }
        },
        ACCESS_TOKEN_METADATA
    ]
};
let PacemWidgetApiManifestElement = class PacemWidgetApiManifestElement extends PacemBearerWidgetElement {
    constructor(_openapi = new SwaggerCmsParser(), _cache = new Storage()) {
        super(buildWidgetMetadata(APIMANIFEST_METADATA));
        this._openapi = _openapi;
        this._cache = _cache;
    }
    propertyChangedCallback(name, old, val, first) {
        super.propertyChangedCallback(name, old, val, first);
        switch (name) {
            case 'url':
            case 'editing':
            case 'editable':
                this._scaffold();
                break;
            case 'usecache':
                this._openapi.cache = val ? this._cache : null;
                break;
        }
    }
    viewActivatedCallback() {
        super.viewActivatedCallback();
        if (this.usecache) {
            this._openapi.cache = this._cache;
        }
        this._scaffold();
    }
    _scaffold() {
        if (this.editing && this.editable && !Utils.isNullOrEmpty(this.url)) {
            this.fetching = true;
            this._openapi.load(this.url).then(s => {
                this.manifest = s;
                this.fetching = false;
            }, _ => {
                this.fetching = false;
            });
        }
    }
};
__decorate([
    Watch({ emit: false, reflectBack: true, converter: PropertyConverters.String })
], PacemWidgetApiManifestElement.prototype, "url", void 0);
__decorate([
    Watch({ emit: false, reflectBack: true, converter: PropertyConverters.Boolean })
], PacemWidgetApiManifestElement.prototype, "usecache", void 0);
__decorate([
    Watch({ converter: PropertyConverters.Json })
], PacemWidgetApiManifestElement.prototype, "manifest", void 0);
PacemWidgetApiManifestElement = __decorate([
    CustomElement({ tagName: P + '-widget-apimanifest' })
], PacemWidgetApiManifestElement);
export { PacemWidgetApiManifestElement };
